// extracted by mini-css-extract-plugin
export default {"img":"icon_img__W14V6","container":"icon_container__RE3-3","title":"icon_title__HqnQE","imgContainer":"icon_imgContainer__bplFQ","grabbed":"icon_grabbed__iV5VV"};